/**
 * Odznak u Košilky v menu — počet košilek, které čekají na MÉ schválení.
 * Počítá se na klientu z dat „Ke schválení" (stejný princip jako odznak převodů
 * u Vyúčtování či obnovy u Karet zaměstnanců — žádný cron na backendu).
 */
import { useKosilkyKeSchvaleni } from '../../api/hooks';

export function useKosilkyKeSchvaleniCount(): number {
  const { data: zadosti = [] } = useKosilkyKeSchvaleni();
  return zadosti.filter((z) => z.stav === 'ceka').length;
}
